var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.hasNewNotification ? 'notification-container' : 'notification-container notification-margin'},[(_vm.hasNewNotification)?_c('div',{staticClass:"new"}):_vm._e(),_vm._v(" "),_c('NotificationsContainer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50a45b9d","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Navbar/NotificationNavbar.vue
// module id = 2101
// module chunks = 1610